<template>
    <div class="app-body">
        <div class="a-flex-rsbc a-ptb-6">
            <span class="a-fs-16 a-fw-b">用户管理</span>
            <div class="a-flex-rfsc">
                <el-button icon="el-icon-upload2" class="s-btn-exp" @click="handlerExport">导出红包赠送记录</el-button>
                <el-dropdown class="a-ml-20" placement="bottom-start" @command="handlerAddCard" v-if="userInfo.dataPermission == 99 && company.isSystem">
                    <el-button icon="el-icon-plus" type="primary" class="s-btn-add">红包</el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="a">XLS批量导入</el-dropdown-item>
                        <el-dropdown-item command="b">XLS批量导入模板</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <el-card class="el-main">
            <le-search-form @reset="handlerRest" @search="handlerSearch" id="leSearch">
                <le-input-num label="用户ID" v-model="pageParam.params.userId" />
                <le-input-num label="用户手机号" v-model="pageParam.params.mobile" />
                <le-input-num label="电子/实体卡" v-model="pageParam.params.cardNo" />
                <le-date-range label="注册时间" :minDate.sync="pageParam.params.createTimeStart" :maxDate.sync="pageParam.params.createTimeEnd" />
            </le-search-form>
            <le-pagview ref="userPage" @setData="setTableData" :pageParam="pageParam" :isFixed="true" :tableRef="$refs.userMGTTable">
                <el-table ref="userMGTTable" :data="tableData" :highlight-current-row="true" style="width: 100%" v-sticky="{ top: 0, parent:'.el-card__body' }">
                    <el-table-column prop="id" label="用户ID" width="120"></el-table-column>
                    <el-table-column prop="nickName" label="用户昵称" width="180"></el-table-column>
                    <el-table-column prop="mobile" label="手机号" width="120"></el-table-column>
                    <!-- <el-table-column prop="mobile" label="电子/实体卡" width="120">
                        <template slot-scope="{ row }">
                            <div class="a-flex-cfsfs" style="align-items: flex-start">
                                <span v-for="(item,index) in row.cardNoList" :key="index" class="stationTag">{{ item }}</span>
                            </div>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="" label="电子/实体卡" min-width="180">
                        <template slot-scope="{ row }">
                            <el-tooltip placement="top-start">
                                <div slot="content" class="a-flex-cfsfs">
                                    <div class="a-flex-rfsc" style="padding-bottom: 6px" v-for="(item, index) in row.cardNoList" :key="index">
                                        <span>{{ index + 1 }}.</span>
                                        <span class="a-ml-10">{{ item }}</span>
                                    </div>
                                </div>
                                <span>{{ row.cardNoList | initCardNoList }}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="是否实名" width="120">
                        <template slot-scope="{ row }">{{ row.isOcr ? '是' : '否' }}
                        </template>
                    </el-table-column> -->
                    <el-table-column label="余额(现金/红包/赠送金)" min-width="180">
                        <template slot-scope="{ row }">&yen;{{ util.numFormat(row.balance) }}/&yen;{{
                                util.numFormat(row.activityBalance)
                        }}/&yen;{{ util.numFormat(row.giftBalance) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="冻结余额(现金/红包/赠送金)" min-width="200">
                        <template slot-scope="{ row }">
                            &yen;{{ util.numFormat(row.lockBalacne) }}/
                            &yen;{{ util.numFormat(row.lockActivity) }}/
                            &yen;{{ util.numFormat(row.lockGift) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="毛豆余额(通用/专属)" min-width="240">
                        <template slot-scope="{ row }">
                            <jd-md-price :number="Number(row.globalPoints || 0) + Number(row.stationPoints || 0)"></jd-md-price>
                            <span>(</span>
                            <jd-md-price :number="Number(row.globalPoints || 0)"></jd-md-price>
                            <span>/</span>
                            <jd-md-price :number="Number(row.stationPoints || 0)"></jd-md-price>
                            <span>)</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="lastLoginTimeText" label="最后登录时间" min-width="160"></el-table-column>
                    <el-table-column prop="createTimeText" label="注册时间" min-width="160"></el-table-column>
                    <el-table-column fixed="right" label="操作" class="a-flex-rcc" width="100">
                        <template slot-scope="{ row }">
                            <!-- <el-tooltip class="item" effect="dark" content="详情" placement="top">
                                <span @click="handlerGoDetail(row.id)"> <img src="../../assets/icon/option-detail.png"
                                        class="a-wh-16" />
                                </span>
                            </el-tooltip> -->
                            <el-button @click="handlerGoDetail(row.id)" type="text">详情</el-button>
                            <el-button @click="handleRefund(row)" type="text" v-if="row.balance">余额退款</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </le-pagview>
        </el-card>
        <le-upload-file-img 
            v-show="false" 
            :uploadUrl="$Config.apiUrl.importUserCoupon" 
            :acceptArr="['.xls','.xlsx']" 
            notnull 
            ref="pic" 
            label="" 
            :limit="999"
            @handleSuccess="importExcSuccess"
            v-model="redXLS"></le-upload-file-img>
        <export-result-list ref="exportResult" :tableData="exportData"></export-result-list>
        <user-refund ref="userRefund"></user-refund>
        <redpackage-record-export ref="redpackageRecordExport"></redpackage-record-export>
    </div>
</template>

<script>
import {
    mapGetters,
    mapActions,
    mapState
} from 'vuex';
import util from '../../utils/util.js'
import * as XLSX from 'xlsx';
import UserRefund from './child/user-refund.vue';
import RedpackageRecordExport from './child/redpackage-record-export.vue';
export default {
    components: {
        UserRefund,
        RedpackageRecordExport
    },
    data() {
        return {
            util: util,
            tableData: [],
            pageParam: {
                url: this.$Config.apiUrl.getUserManagerList,
                method: 'post',
                params: {
                    mobile: '',
                    userId: '',
                    cardNo: '',
                    createTimeStart: '',
                    createTimeEnd: ''
                },
                freshCtrl: 1,
            },
            redXLS: '',
            exportData: [],
            exportLoading: false,
        }
    },
    computed: {
        ...mapState({
            company: state => state.company.company,
            userInfo: state => state.user.user,
        })
    },
    mounted() { },
    filters: {
        initCardNoList (arr) {
            if(arr && arr.length) {
                if(arr.length > 1) {
                    return arr[0] + '...等' + arr.length + '张卡片'
                }else {
                    return arr[0]
                }
            }else {
                return '-'
            }
        },
    },
    methods: {
        //获取用户列表
        setTableData(data) {
            this.tableData = data
        },
        handlerRest() {
            this.pageParam.params = {
                mobile: '',
                userId: '',
                cardNo: '',
                createTimeStart: '',
                createTimeEnd: ''
            }
            this.handlerSearch()
        },

        handlerSearch() {
            this.$refs['userPage'].pageNum = 1
            this.pageParam.freshCtrl++
        },
        exportRed () {
            this.$refs['pic'].$refs["upload"].$refs["upload-inner"].handleClick();
        },
        handlerAddCard(command) {
            if (command == 'a') {
                // 批量导入
                this.$refs['pic'].$refs["upload"].$refs["upload-inner"].handleClick();
            } else if (command == 'b') {
                this.exportExcel([
                    {
                        '序号': '1',
                        '电话号码': '1xxxxxxxxxxx',
                        '红包金额（元）': '0',
                        '商户ID ': 'xxxxx',
                        '备注（选填）': 'xxxxx',
                    }
                ], '用户红包导入模版');
            }
        },
        exportExcel(data, fileName = '导出数据', options = {}) {
            // 1. 创建工作簿
            const workbook = XLSX.utils.book_new();
            // 2. 处理多Sheet情况
            if (Array.isArray(data)) {
                // 单Sheet：直接是数组
                const worksheet = XLSX.utils.json_to_sheet(data);
                // 设置列宽
                if (options.columnWidths) {
                    worksheet['!cols'] = options.columnWidths;
                }
                XLSX.utils.book_append_sheet(workbook, worksheet, options.sheetName || 'Sheet1');
            } else {
                // 多Sheet：data是对象，key是sheet名，value是数组
                Object.entries(data).forEach(([sheetName, sheetData]) => {
                    if (Array.isArray(sheetData) && sheetData.length > 0) {
                        const worksheet = XLSX.utils.json_to_sheet(sheetData);
                        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
                    }
                });
            }
            
            // 3. 写入文件
            try {
                XLSX.writeFile(workbook, `${fileName}.xlsx`);
                console.log('Excel文件下载成功');
                return true;
            } catch (error) {
                console.error('Excel生成失败:', error);
                return false;
            }
        },
        importExcSuccess (data) {
            this.$message.success('导入成功')
            this.exportData = data
            if(data && data.length){
                this.$refs['exportResult'].dialogVisible = true
            }
            this.pageParam.freshCtrl++; // 重新请求表格数据
        },
        //跳转详情
        handlerGoDetail(id) {
            this.$router.push({
                path: '/userMGT/userMGT-detail',
                query: {
                    id: id
                }
            })
        },
        handleRefund (datas) {
            this.$refs['userRefund'].userId = datas.id
            this.$refs['userRefund'].getUserBalance()
            this.$refs['userRefund'].dialogVisible = true
        },
        handlerExport () {
            this.$refs['redpackageRecordExport'].dialogVisible = true
        }

    },
}
</script>

<style scoped lang="scss">
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
		/*width: 0;宽度为0隐藏*/
		width: 0 !important;
		height: 0 !important;
	}
	/deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
		height: 100% !important;
	}
</style>
